import { render, staticRenderFns } from "./BookVisitModal.vue?vue&type=template&id=34987735&"
import script from "./BookVisitModal.vue?vue&type=script&lang=js&"
export * from "./BookVisitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports